export default "__VITE_ASSET__DMv$WXTO__"